import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import { CopiableText } from '../../../../generic';
import Button, { BUTTON_TYPE } from '../../../../generic/Button';
import ListRowDetailsSeparator from '../../../../generic/List/ListRowDetailsSeparator';
import Tooltip from '../../../../generic/Tooltip';
import type { Dependency } from '../../../../../../shared/dependenciesV2';
import type { DependencyV2Modals } from '../../hooks/useDependencyModals';

import styles from './DependencyRow.module.less';

type Props = {
  dependency: Dependency;
  modals: DependencyV2Modals;
  isProjectScope: boolean;
};

const DependencyData: VoidFunctionComponent<Props> = ({ dependency, modals, isProjectScope }) => {
  const revision = new Locator(dependency.locator);
  const locator = revision.toFullString();
  const originPathsText = dependency.originPaths.join(', ');
  const isTransitive = dependency.depth > 1;
  // Release groups might have multiple CPEs for the same dependency, but they are most likely the same.
  // For now, we just show the first one.
  const cpe = dependency.cpes[0];

  const openPathModal = () =>
    modals.viewRelationshipsModal.onOpen({
      context: { title: dependency.title, revision: locator },
    });

  return (
    <div className={styles.DependencyInfoData}>
      <CopiableText id={locator} name="locator" value={locator} />
      {dependency.originPaths && dependency.originPaths.length > 0 && (
        <>
          <ListRowDetailsSeparator />
          <Tooltip id={`${locator}-originpaths`} tooltip={`Origin: ${originPathsText}`}>
            <span className={styles.originPaths}>{originPathsText}</span>
          </Tooltip>
        </>
      )}
      {cpe && (
        <>
          <ListRowDetailsSeparator />
          <CopiableText id={locator} name="CPE" value={cpe} />
        </>
      )}
      {isTransitive && isProjectScope && (
        <>
          <ListRowDetailsSeparator />
          <Button type={BUTTON_TYPE.ANCHOR} onClick={openPathModal}>
            View path
          </Button>
        </>
      )}
    </div>
  );
};

export default DependencyData;
